import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import LocationsList from 'components/Location/LocationsList';
import SortedLocations from 'components/Location/SortedLocationsList';
import LocationListSection from 'bento-ordering/locations/components/LocationListSection';
import { LOCATION_LIST_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

const SCROLL_TO_ID = 'locations-list-container';
function AllLocationsList({
  beginOrder,
  closedLocations = [],
  LocationsListItemComponent,
  locationsForPickup = [],
  locationsThatDeliverToAddress = [],
  restaurantLocations = [],
  selectedMapLocation = 0
}) {
  return (
    <Box mt={3} id={SCROLL_TO_ID}>
      {/* we know we need to render sorted locations if there are any locationsThatDeliverToAddress or locationsForPickup */}
      {locationsThatDeliverToAddress.length || locationsForPickup.length ? (
        <SortedLocations
          beginOrder={beginOrder}
          closedLocations={closedLocations}
          locationsForPickup={locationsForPickup}
          locationsThatDeliverToAddress={locationsThatDeliverToAddress}
          LocationsListItemComponent={LocationsListItemComponent}
          selectedMapLocation={selectedMapLocation}
        />
      ) : (
        <LocationListSection
          title="All Locations"
          dataTestId="unsorted-locations"
        >
          <LocationsList
            beginOrder={beginOrder}
            locations={restaurantLocations}
            LocationsListItemComponent={LocationsListItemComponent}
            selectedMapLocation={selectedMapLocation}
          />
        </LocationListSection>
      )}
    </Box>
  );
}

AllLocationsList.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  closedLocations: LOCATION_LIST_PROPTYPES,
  LocationsListItemComponent: PropTypes.elementType.isRequired,
  locationsForPickup: LOCATION_LIST_PROPTYPES,
  locationsThatDeliverToAddress: LOCATION_LIST_PROPTYPES,
  restaurantLocations: LOCATION_LIST_PROPTYPES,
  selectedMapLocation: PropTypes.number
};

export default AllLocationsList;
